// extracted by mini-css-extract-plugin
export var blogSec = "style-module--blogSec--c6ca7";
export var blog_textarea_empty = "style-module--blog_textarea_empty--dd966";
export var contact_box = "style-module--contact_box--7d927";
export var features_section = "style-module--features_section--a9210";
export var link = "style-module--link--bc82e";
export var more_btn = "style-module--more_btn--75ee5";
export var pallax_box = "style-module--pallax_box--cf668";
export var pallax_group = "style-module--pallax_group--25ea8";
export var section_description = "style-module--section_description--98e8a";
export var service_bottom_group = "style-module--service_bottom_group--e5134";
export var service_box = "style-module--service_box--8ba18";
export var service_group = "style-module--service_group--c5c53";
export var service_section = "style-module--service_section--7835a";
export var service_section_heading = "style-module--service_section_heading--4f9a9";
export var service_textbox = "style-module--service_textbox--82d14";
export var textbox = "style-module--textbox--2ed98";
export var topSec = "style-module--topSec--0533f";
export var top_link_box = "style-module--top_link_box--4b2ad";
export var top_link_group = "style-module--top_link_group--e57ed";
export var top_link_section = "style-module--top_link_section--dbbd0";
export var top_visual_media_outer = "style-module--top_visual_media_outer--b112e";